import React, { useState, useEffect } from "react";

const Comprar = () => {
  const [buy, setBuy] = useState([
    {
      numb: "./images/numb1.svg",
      qst: "Selección de un NFT de una obra de arte",
      ans: "Una vez seleccionado el NFTs iniciaremos el proceso de compra. Para ello es fundamental conectarse con la wallet al marketplace. Este proceso es totalmente seguro.",
    },
    {
      numb: "./images/numb2.svg",
      qst: "Selección de un NFT de una obra de arte",
      ans: "Una vez seleccionado el NFTs iniciaremos el proceso de compra. Para ello es fundamental conectarse con la wallet al marketplace. Este proceso es totalmente seguro.",
    },
    {
      numb: "./images/numb3.svg",
      qst: "Compra completada del NFT Art",
      ans: "Una vez seleccionado el NFTs iniciaremos el proceso de compra. Para ello es fundamental conectarse con la wallet al marketplace. Este proceso es totalmente seguro.",
    },
    {
      numb: "./images/numb4.svg",
      qst: "Reconocimiento de la compra del NFT",
      ans: "Una vez seleccionado el NFTs iniciaremos el proceso de compra. Para ello es fundamental conectarse con la wallet al marketplace. Este proceso es totalmente seguro.",
    },
    {
      numb: "./images/numb5.svg",
      qst: "Guardar, revender o regalar",
      ans: "Una vez seleccionado el NFTs iniciaremos el proceso de compra. Para ello es fundamental conectarse con la wallet al marketplace. Este proceso es totalmente seguro.",
    },
  ]);
  const [qst, setQst] = useState([
    {
      qst: "¿Es seguro vender mi arte en el marketplace?",
      ans: "SI. Gracias al blockchain y a los smart contracts auditados ofrecemos una seguridad inquebrantable. ",
    },
    {
      qst: "¿Se puede pagar o cobrar con criptomonedas? ¿Y con FIAT?",
      ans: "SI. Gracias al blockchain y a los smart contracts auditados ofrecemos una seguridad inquebrantable. ",
    },
    {
      qst: "¿Existe algún tipo de coste adicional para un artista?",
      ans: "SI. Gracias al blockchain y a los smart contracts auditados ofrecemos una seguridad inquebrantable. ",
    },
  ]);

  const Questions = ({ data }) => {
    const [open, setOpen] = useState(false);
    return (
      <div className="item flex flex-col">
        <div className="qst flex aic justify-between">
          <div className="qst-lbl">{data.qst}</div>
          <div className="ico cursor-pointer" onClick={(e) => setOpen(!open)}>
            {open ? (
              <img src="./images/minusIcon.svg" className="img" />
            ) : (
              <img src="./images/PlusIcon.svg" className="img" />
            )}
          </div>
        </div>
        <div className={`ans ${open ? "open" : ""}`}>
          SI. Gracias al blockchain y a los smart contracts auditados ofrecemos
          una seguridad inquebrantable.
        </div>
      </div>
    );
  };
  const HowBuy = ({ data }) => {
    const [open, setOpen] = useState(false);
    return (
      <div className="tab flex aic">
        <div className="numb flex aic jc">
          <img src={data.numb} className="ico" />
        </div>
        <div className={`qst-tab flex flex-col ${open ? "open" : ""}`}>
          <div
            className={`buy-qst flex aic justify-between ${open ? "open" : ""}`}
          >
            <div className={`lbl ${open ? "open" : ""}`}>{data.qst}</div>
            <div
              className="icons flex aic jc cursor-pointer"
              onClick={(e) => setOpen(!open)}
            >
              {open ? (
                <img src="./images/minusIcon.svg" className="ico" />
              ) : (
                <img src="./images/PlusIcon1.svg" className="ico" />
              )}
            </div>
          </div>
          <div className={`ans ${open ? "open" : "closed"}`}>{data.ans}</div>
        </div>
      </div>
    );
  };

  return (
    <div className="comprar-page flex flex-col">
      <div className="hero-sec flex aic jc">
        <div className="hero-sec-desc">
          "Comprar y vender NFTs de <br />
          arte nunca ha sido tan fácil ni
          <br /> accesible como con
          <br /> NFTsTotal.art.“
        </div>
      </div>
      <div className="nfts-future flex flex-col">
        <div className="wrap wrapWidth flex flex-col">
          <div className="nft-present flex flex-col">
            <div className="page-tag">“NFT es presente, NFT es futuro.“</div>
            <div className="pres-desc">
              Somos el marketplace para la compra y venta de NFTs especializado
              <br />
              en el sector del arte. Compra obras de arte digital o físico
              <br />
              respaldadas por un NFT de una manera segura, transparente, eficaz,
              <br />
              legal, profesional y efectiva.{" "}
            </div>
          </div>
          <div className="what-nft-sec flex flex-col">
            <div className="page-tag">¿Qué son los NFTs?</div>
            <div className="what-bg flex flex-col aic jc">
              <div className="desc">
                Los tokens no fungibles o NFTs (por sus siglas en inglés Non
                Fungible Tokens) son activos únicos e irrepetibles, que no se
                pueden modificar, consumir, ni intercambiar por otro igual.
                Cuentan con un certificado digital de autenticidad.
                <br /> <br /> Como por ejemplo cuando un artista crea una obra
                de arte, garantizando que sea única e irrepetible y además su
                valor reside en que esa obra de arte jamás será replicada.{" "}
                <br /> <br /> Los NFTs funcionan a través de la tecnología
                blockchain o de cadena de bloques o nodos enlazados y asegurados
                mediante criptografía.
              </div>
            </div>
          </div>
          <div className="buy-nft flex aic">
            <div className="left flex aic jc">
              <div className="page-tag">¿Por qué comprar NFTs?</div>
            </div>
            <div className="right flex flex-col">
              <div className="item flex aic">
                <div className="numb">01.</div>
                <div className="dec">
                  <span> Son únicos: </span>gracias a su sistema de
                  certificación, no pueden darse duplicidades.{" "}
                  <span>Todos los NFTs son únicos.</span>
                </div>
              </div>
              <div className="item flex aic">
                <div className="numb">02.</div>
                <div className="dec">
                  <span> Para coleccionar:</span>Para coleccionar: los NFTs, al
                  igual que las obras de arte físicas, pueden generar
                  colecciones que aportan un valor extra al propio token.
                </div>
              </div>
              <div className="item flex aic">
                <div className="numb">03.</div>
                <div className="dec">
                  <span>Variedad:</span> el amplio abanico de NFTs que
                  proporciona el mercado un gran dinamismo entre la oferta y la
                  demanda.
                </div>
              </div>
              <div className="item flex aic">
                <div className="numb">04.</div>
                <div className="dec">
                  <span>Seguridad:</span> gracias al blockchain, el NFT está
                  blindado contra las copias sin autorización, ofreciendo así
                  una seguridad sin precedentes.
                </div>
              </div>
            </div>
          </div>
          <div className="why-best-us flex flex-col">
            <div className="action flex aic jc">
              <div className="btn button">
                Quiero comprar arte NFT en nftstotal.art
              </div>
            </div>
            <div className="page-tag">
              ¿Por qué somos tu mejor opción para comprar NFTs?
            </div>
            <div className="why-best-point">
              <div className="item flex aic">
                <div className="numb">01.</div>
                <div className="dec">
                  <span>Seguridad:</span> seleccionamos cada NFT y artista de
                  manera individual, todos los NFTs están auditados.
                </div>
              </div>
              <div className="item flex aic">
                <div className="numb">02.</div>
                <div className="dec">
                  <span>Tranquilidad:</span> nos ocupamos de todo: atención al
                  comprador, selección de artistas y obras, creación de smart
                  contracts, cobros, etc.).
                </div>
              </div>
              <div className="item flex aic">
                <div className="numb">03.</div>
                <div className="dec">
                  <span>Control:</span> Control: controlamos todo el proceso de
                  subida y venta para una mejor experiencia de cliente.
                </div>
              </div>
              <div className="item flex aic">
                <div className="numb">04.</div>
                <div className="dec">
                  <span>Servicios integrales:</span> ofrecemos un servicio
                  integral a medida, en base a las necesidades de cada cliente.
                </div>
              </div>
              <div className="item flex aic">
                <div className="numb">05.</div>
                <div className="dec">
                  <span>Respaldo:</span> Respaldo: asesoramiento integral y
                  formación permanente para la conceptualización de NFTs y
                  ventas de los mismos.
                </div>
              </div>
              <div className="item flex aic">
                <div className="btn button">
                  Contacte con nosotros para obtener más información.
                </div>
              </div>
            </div>
          </div>
          <div className="wrok-type flex flex-col">
            <div className="wrap wrapWidth flex">
              <div className="left flex">
                <div className="bgImage flex aic jc">
                  <div className="tag">
                    Tipos de NFTs
                    <br /> que puedes comprar
                  </div>
                </div>
              </div>
              <div className="right flex flex-col">
                <div className="right-desc">
                  Compra de manera segura con un respaldo integral nativo en el
                  marketplace referente del sector del arte de habla hispana.
                </div>
                <div className="right-blk">
                  <div className="work-card flex aic">
                    <img src="./images/wk1.svg" className="img" />
                    <div className="lbl">Arte digital</div>
                  </div>
                  <div className="work-card flex aic">
                    <img src="./images/wk2.svg" className="img" />
                    <div className="lbl">Pintura</div>
                  </div>
                  <div className="work-card flex aic">
                    <img src="./images/wk3.svg" className="img" />
                    <div className="lbl">Escultura</div>
                  </div>
                  <div className="work-card flex aic">
                    <img src="./images/wk4.svg" className="img" />
                    <div className="lbl">Fotografía</div>
                  </div>
                  <div className="work-card flex aic">
                    <img src="./images/wk5.svg" className="img" />
                    <div className="lbl">Vídeo</div>
                  </div>
                  <div className="work-card flex aic">
                    <img src="./images/wk6.svg" className="img" />
                    <div className="lbl">Realidad virtual</div>
                  </div>
                  <div className="work-card flex aic">
                    <img src="./images/wk7.svg" className="img" />
                    <div className="lbl">Libros</div>
                  </div>
                  <div className="work-card flex aic">
                    <img src="./images/wk8.svg" className="img" />
                    <div className="lbl">
                      Obras <br />
                      tokenizadas
                    </div>
                  </div>
                </div>
                <div className="action flex aic jc">
                  <div className="btn button">Descubre nuestro marketplace</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="nft-phy flex">
        <div className="item flex flex-col">
          <div className="item-tag">NFTs en obras físicas</div>
          <div className="item-dec">
            Con la compra de un NFTs de una obra de arte física, obtendrás el
            NFT como titulo de propiedad digital y la obra de arte. El
            propietario te la enviará a la dirección solicitada.{" "}
          </div>
          <div className="item-action flex aic jc">
            <div className="btn button">Comprar NFTs de obras fisicas</div>
          </div>
        </div>
        <div className="item flex flex-col">
          <div className="item-tag">NFTs en obras físicas</div>
          <div className="item-dec">
            Con la compra de un NFTs de una obra de arte física, obtendrás el
            NFT como titulo de propiedad digital y la obra de arte. El
            propietario te la enviará a la dirección solicitada.{" "}
          </div>
          <div className="item-action flex aic jc">
            <div className="btn button">Comprar NFTs de obras fisicas</div>
          </div>
        </div>
        <div className="item flex flex-col">
          <div className="item-tag">NFTs en obras físicas</div>
          <div className="item-dec">
            Con la compra de un NFTs de una obra de arte física, obtendrás el
            NFT como titulo de propiedad digital y la obra de arte. El
            propietario te la enviará a la dirección solicitada.{" "}
          </div>
          <div className="item-action flex aic jc">
            <div className="btn button">Comprar NFTs de obras fisicas</div>
          </div>
        </div>
      </div>
      <div className="buy-nft flex flex-col">
        <div className="wrap wrapWidth flex flex-col aic">
          <div className="page-tag">
            ¿Cómo comprar NFTs de arte con total seguridad?
          </div>
          <div className="page-desc">
            Trabajamos por y para tu tranquilidad. Cuentas con nuestro respaldo
            en todo el proceso de compra garantizandote al 100% no comprar un
            NFT replicado.
          </div>
          <div className="how-buy-tabs flex flex-col">
            {buy.map((item, index) => (
              <HowBuy data={item} />
            ))}
          </div>
          <div className="action flex aic jc">
            <div className="btn button">Quiero comprar arte NFT </div>
          </div>
        </div>
      </div>
      <div className="slider flex flex-col jc">
        <div className="wrap wrapWidth flex">
          <div className="left flex jc flex-col">
            <img src="./images/logo.svg" className="logo-img" />
            <div className="numbs">4,7/5</div>
            <div className="lbl">Excelente</div>
          </div>
          <div className="center flex flex-col aic jc">
            <img src="./images/auth_users2.png" className="user-img" />
            <div className="name">@autor</div>
          </div>
          <div className="right flex aic jc">
            <div className="box flex flex-col">
              <div className="box-hder flex justify-between">
                <div className="tag">Una compra de 10</div>
                <div className="box-numbs flex aic jc">5/5</div>
              </div>
              <div className="box-desc">
                Es el único marketplace cuya atencón al cliente y su experiencia
                de compra es de 10. Se agradece poder hablar con una persona en
                caso de alguna duda. Totalmente recomendable para comprar NFTs
                de arte.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="faqs-sec flex flex-col">
        <div className="wrap wrapWidth flex flex-col">
          <div className="faq-tag">Preguntas frecuentes</div>
          <div className="faqs-blk flex flex-col">
            {qst.map((item, index) => (
              <Questions data={item} />
            ))}
          </div>
        </div>
      </div>
      <div className="faqs-sallers flex flex-col">
        <div className="wrap wrapWidth flex flex-col">
          <div className="tag">
            Consulta nuestras FAQs sobre la compra de NFTs Art
          </div>
        </div>
      </div>
    </div>
  );
};

export default Comprar;
